import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { cloneDeep, debounce } from 'lodash';
import { AppSelectorService } from '../services/app-selector/app-selector.service';

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss']
})
export class CustomDropdownComponent implements OnInit {

  public inputPlaceholder: string = '';
  @Input() itemsMap: object = {};
  @Input() clonedItemsMap: object = {};
  @Input() tabs: Array<object> = [{
    name: 'all',
    value: 'ALL'
  }, {
    name: 'active',
    value: 'Active'
  }, {
    name: 'inactive',
    value: 'Inactive'
  }];
  @Input() selectedTabIndex: number = 0;
  @Input() tabIndexLabelMap: object = {
    1: 'active',
    2: 'inactive'
  }
  @Input() listSubHeader: object = {
    active: 'Active',
    inactive: 'Inactive'
  }
  @Input() singleSelect?: boolean = false;
  @Output() shouldShowMenuClose = new EventEmitter<boolean>();
  @Output() valueChangeCallback = new EventEmitter<any>();
  public selectAll: boolean = false;
  public objectKeys = Object.keys;
  selectedApp: any;
  selecteditem: any;

  constructor(private appSelectorService: AppSelectorService) { }

  ngOnInit() {
    this.selectedApp = {
      app: undefined,
      index: -1
    };
    this.itemsMap = cloneDeep(this.clonedItemsMap);
  }

  valueChange = debounce((text: string) => {
    this.inputPlaceholder = text;
    if (!text) {
      this.selectAll = false;
      this.populateItemsMap();
    } else {
      if (this.selectedTabIndex === 0) {
        this.filterAllItems(this.inputPlaceholder);
      } else {
        const key = this.tabIndexLabelMap[this.selectedTabIndex];
        if (this.itemsMap.hasOwnProperty(key)) {
          this.itemsMap[key] = this.itemsMap[key].filter((item: any) => {
            if (item.lowerCaseName) {
              return item.lowerCaseName.includes(text.toLowerCase());
            }
            return item.name.includes(text);
          });
        }
      }
    }
    const map = {
      selectedTabIndex: this.selectedTabIndex,
      selectedValues: this.itemsMap
    }
    this.valueChangeCallback.emit(map);
  }, 300);

  toggleAll() {
    if (this.selectAll) {
      this.objectKeys(this.itemsMap).forEach(itemKey => {
        this.itemsMap[itemKey].forEach((item: any) => {
          item.checked = true;
        });
      });
    } else {
      this.objectKeys(this.itemsMap).forEach(itemKey => {
        this.itemsMap[itemKey].forEach((item: any) => {
          item.checked = false;
        });
      });
    }
    const map = {
      selectedTabIndex: this.selectedTabIndex,
      selectedValues: this.itemsMap
    }
    this.valueChangeCallback.emit(map);
  }

  toggleItem() {
    const map = {
      selectedTabIndex: this.selectedTabIndex,
      selectedValues: this.itemsMap
    }
    this.valueChangeCallback.emit(map);
  }

  handleTabChange(event) {
    this.selectAll = false;
    this.selectedTabIndex = event.index;
    if (event.index === 0) {
      this.populateItemsMap();
    } else {
      this.itemsMap = {};
      const key = this.tabIndexLabelMap[this.selectedTabIndex];
      if (this.clonedItemsMap.hasOwnProperty(key)) {
        this.itemsMap[key] = cloneDeep(this.clonedItemsMap[key]);
        if (this.inputPlaceholder) {
          this.itemsMap[key] = this.itemsMap[key].filter((item: any) => item.name.includes(this.inputPlaceholder));
        }
      }
    }
  }

  populateItemsMap() {
    this.itemsMap = {};
    if (this.selectedTabIndex === 0) {
      this.itemsMap = cloneDeep(this.clonedItemsMap);
      if (this.inputPlaceholder) {
        this.filterAllItems(this.inputPlaceholder);
      }
    } else {
      const key = this.tabIndexLabelMap[this.selectedTabIndex];
      if (this.clonedItemsMap.hasOwnProperty(key)) {
        this.itemsMap[key] = this.clonedItemsMap[key];
      }
    }
  }

  selectAppDataID(app: any) {
    this.shouldShowMenuClose.emit(false)
    this.appSelectorService.setSelectedApp(app);
  }

  filterAllItems(searchText: string): void {
    this.objectKeys(this.itemsMap).forEach(itemKey => {
      this.itemsMap[itemKey] = this.itemsMap[itemKey].filter((item: any) => {
        if (item.lowerCaseName) {
          return item.lowerCaseName.includes(searchText.toLowerCase());
        }
        return item.name.includes(searchText);
      });
    });
  }
}
